import type { PublicDocumentBranding, PaymentInstruction } from '@1financial/shared';
export function DocumentBranding({ branding }: { branding?: PublicDocumentBranding }) {
  return <div className="space-y-2 min-w-0 break-words">
    <div className="flex flex-wrap items-center gap-3">
      {branding?.logoUrl && <img src={branding.logoUrl} alt="Company logo" className="max-w-[160px] max-h-16 object-contain" />}
      <div className="font-semibold text-lg" style={{ color: branding?.accentColor }}>{branding?.companyName ?? '1Financial'}</div>
    </div>
    {branding?.addressBlock && <p className="text-xs text-muted whitespace-pre-wrap">{branding.addressBlock}</p>}
    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted">
      {branding?.contactEmail && <span>{branding.contactEmail}</span>}
      {branding?.contactPhone && <span>{branding.contactPhone}</span>}
      {branding?.website && <a href={branding.website} rel="noopener noreferrer" target="_blank" className="break-all underline">{branding.website}</a>}
    </div>
    {branding?.taxRegistration && <p className="text-xs text-muted">Tax registration: {branding.taxRegistration}</p>}
  </div>;
}
export function PaymentInstructions({ instructions }: { instructions: PaymentInstruction[] }) {
  if (!instructions.length) return null;
  return <section aria-label="Payment instructions" className="space-y-3 min-w-0">
    <h2 className="font-semibold text-white">Payment instructions</h2>
    {instructions.map((bank, index) => <div key={index} className="border border-border rounded-lg p-4 space-y-2 min-w-0 break-words">
      <h3 className="text-sm font-medium text-white">{bank.label}</h3>
      <dl className="text-sm space-y-1">
        {([
          ['Bank', bank.bankName], ['Account holder', bank.accountHolder], ['Account number', bank.accountNumber],
          ['IBAN', bank.iban], ['SWIFT / BIC', bank.swiftBic], ['Routing / sort code', bank.routingCode],
          ['Branch', bank.branch], ['Currency', bank.currencyLabel],
        ] as const).filter(([, value]) => value).map(([label, value]) => <div key={label} className="grid grid-cols-1 sm:grid-cols-[150px_minmax(0,1fr)] gap-1"><dt className="text-muted">{label}</dt><dd className="text-white break-all">{value}</dd></div>)}
      </dl>
      {bank.publicNotes && <p className="text-sm text-muted whitespace-pre-wrap">{bank.publicNotes}</p>}
    </div>)}
  </section>;
}
